export const COMPONENT_TYPES: { value: string; label: string }[] = [
  { value: "software", label: "Software" },
  { value: "hardware", label: "Hardware" },
  { value: "service", label: "Service" },
  { value: "policy", label: "Policy" },
  { value: "process", label: "Process" },
  { value: "procedure", label: "Procedure" },
  { value: "plan", label: "Plan" },
  { value: "guidance", label: "Guidance" },
  { value: "standard", label: "Standard" },
  { value: "validation", label: "Validation" },
];

export type SspInheritanceType = "" | "application" | "service";

export const SSP_INHERITANCE_TYPE_OPTIONS: {
  value: SspInheritanceType;
  label: string;
}[] = [
  { value: "application", label: "Application" },
  { value: "service", label: "Service" },
];
